var map = {
	"./+admin": [
		"./src/app/+admin/admin.module.ts",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~service~t~f337c529",
		"default~admin~allow-phone-number~change-plan-history~inquiry~page~plan~promotion~service~sweetalert2~8c1300c7",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~ticket~to~1c8a400a",
		"default~admin~allow-phone-number~change-plan-history~inquiry~plan~promotion~service~ticket~topup-cre~9977b9f9",
		"default~admin~allow-phone-number~dashboard~page~plan~user",
		"default~admin~user",
		"admin"
	],
	"./+allow-phone-number": [
		"./src/app/+admin/+allow-phone-number/allow-phone-number.module.ts",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~service~t~f337c529",
		"default~admin~allow-phone-number~change-plan-history~inquiry~page~plan~promotion~service~sweetalert2~8c1300c7",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~ticket~to~1c8a400a",
		"default~admin~allow-phone-number~change-plan-history~inquiry~plan~promotion~service~ticket~topup-cre~9977b9f9",
		"default~admin~allow-phone-number~dashboard~page~plan~user",
		"allow-phone-number"
	],
	"./+change-plan-history": [
		"./src/app/+admin/+change-plan-history/change-plan-history.module.ts",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~service~t~f337c529",
		"default~admin~allow-phone-number~change-plan-history~inquiry~page~plan~promotion~service~sweetalert2~8c1300c7",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~ticket~to~1c8a400a",
		"default~admin~allow-phone-number~change-plan-history~inquiry~plan~promotion~service~ticket~topup-cre~9977b9f9",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history~user",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history",
		"default~change-plan-history~inquiry~plan~promotion~service~ticket~topup-credit-history",
		"default~change-plan-history~inquiry~plan~ticket~topup-credit-history",
		"change-plan-history"
	],
	"./+dashboard": [
		"./src/app/+admin/+dashboard/dashboard.module.ts",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~service~t~f337c529",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~ticket~to~1c8a400a",
		"default~admin~allow-phone-number~dashboard~page~plan~user",
		"dashboard"
	],
	"./+inquiry": [
		"./src/app/+admin/+inquiry/inquiry.module.ts",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~service~t~f337c529",
		"default~admin~allow-phone-number~change-plan-history~inquiry~page~plan~promotion~service~sweetalert2~8c1300c7",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~ticket~to~1c8a400a",
		"default~admin~allow-phone-number~change-plan-history~inquiry~plan~promotion~service~ticket~topup-cre~9977b9f9",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history~user",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history",
		"default~change-plan-history~inquiry~plan~promotion~service~ticket~topup-credit-history",
		"default~change-plan-history~inquiry~plan~ticket~topup-credit-history",
		"inquiry"
	],
	"./+page": [
		"./src/app/+admin/+page/page.module.ts",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~service~t~f337c529",
		"default~admin~allow-phone-number~change-plan-history~inquiry~page~plan~promotion~service~sweetalert2~8c1300c7",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~ticket~to~1c8a400a",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history~user",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history",
		"default~admin~allow-phone-number~dashboard~page~plan~user",
		"page"
	],
	"./+plan": [
		"./src/app/+admin/+plan/plan.module.ts",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~service~t~f337c529",
		"default~admin~allow-phone-number~change-plan-history~inquiry~page~plan~promotion~service~sweetalert2~8c1300c7",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~ticket~to~1c8a400a",
		"default~admin~allow-phone-number~change-plan-history~inquiry~plan~promotion~service~ticket~topup-cre~9977b9f9",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history~user",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history",
		"default~change-plan-history~inquiry~plan~promotion~service~ticket~topup-credit-history",
		"default~admin~allow-phone-number~dashboard~page~plan~user",
		"default~change-plan-history~inquiry~plan~ticket~topup-credit-history",
		"plan"
	],
	"./+promotion": [
		"./src/app/+admin/+promotion/promotion.module.ts",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~service~t~f337c529",
		"default~admin~allow-phone-number~change-plan-history~inquiry~page~plan~promotion~service~sweetalert2~8c1300c7",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~ticket~to~1c8a400a",
		"default~admin~allow-phone-number~change-plan-history~inquiry~plan~promotion~service~ticket~topup-cre~9977b9f9",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history~user",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history",
		"default~change-plan-history~inquiry~plan~promotion~service~ticket~topup-credit-history",
		"promotion"
	],
	"./+service": [
		"./src/app/+admin/+service/service.module.ts",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~service~t~f337c529",
		"default~admin~allow-phone-number~change-plan-history~inquiry~page~plan~promotion~service~sweetalert2~8c1300c7",
		"default~admin~allow-phone-number~change-plan-history~inquiry~plan~promotion~service~ticket~topup-cre~9977b9f9",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history~user",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history",
		"default~change-plan-history~inquiry~plan~promotion~service~ticket~topup-credit-history",
		"service"
	],
	"./+ticket": [
		"./src/app/+admin/+ticket/ticket.module.ts",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~service~t~f337c529",
		"default~admin~allow-phone-number~change-plan-history~inquiry~page~plan~promotion~service~sweetalert2~8c1300c7",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~ticket~to~1c8a400a",
		"default~admin~allow-phone-number~change-plan-history~inquiry~plan~promotion~service~ticket~topup-cre~9977b9f9",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history~user",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history",
		"default~change-plan-history~inquiry~plan~promotion~service~ticket~topup-credit-history",
		"default~change-plan-history~inquiry~plan~ticket~topup-credit-history",
		"ticket"
	],
	"./+topup-credit-history": [
		"./src/app/+admin/+topup-credit-history/topup-credit-history.module.ts",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~service~t~f337c529",
		"default~admin~allow-phone-number~change-plan-history~inquiry~page~plan~promotion~service~sweetalert2~8c1300c7",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~ticket~to~1c8a400a",
		"default~admin~allow-phone-number~change-plan-history~inquiry~plan~promotion~service~ticket~topup-cre~9977b9f9",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history~user",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history",
		"default~change-plan-history~inquiry~plan~promotion~service~ticket~topup-credit-history",
		"default~change-plan-history~inquiry~plan~ticket~topup-credit-history",
		"topup-credit-history"
	],
	"./+user": [
		"./src/app/+admin/+user/user.module.ts",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~service~t~f337c529",
		"default~admin~allow-phone-number~change-plan-history~inquiry~page~plan~promotion~service~sweetalert2~8c1300c7",
		"default~admin~allow-phone-number~change-plan-history~dashboard~inquiry~page~plan~promotion~ticket~to~1c8a400a",
		"default~admin~allow-phone-number~change-plan-history~inquiry~plan~promotion~service~ticket~topup-cre~9977b9f9",
		"default~change-plan-history~inquiry~page~plan~promotion~service~ticket~topup-credit-history~user",
		"default~admin~allow-phone-number~dashboard~page~plan~user",
		"default~admin~user",
		"user"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;